/**
 * ComparisonLegend component barrel export
 *
 * View-only component for chart comparison legend dots.
 */

export { default } from "./ComparisonLegendView";
